import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import Lottie from 'lottie-react';

import confetti from 'src/assets/confetti.json';

const lottieStyle = { height: '100%', width: '100%' } as const;
const lottieRendererSettings = { preserveAspectRatio: 'xMidYMid slice' } as const;

export function ConfettiOverlay(): JSX.Element | null {
  const hasPlayedRef = useRef(false);
  const [isPlaying, setIsPlaying] = useState(() => !hasPlayedRef.current);

  useEffect(() => {
    hasPlayedRef.current = true;
  }, []);

  if (!isPlaying) {
    return null;
  }

  return (
    <LottieOverlay data-testid='payment-complete-confetti-overlay'>
      <Lottie
        animationData={confetti}
        style={lottieStyle}
        loop={false}
        onComplete={() => setIsPlaying(false)}
        rendererSettings={lottieRendererSettings}
      />
      <LottieHidden className='tablet-plus'>
        <Lottie animationData={confetti} style={lottieStyle} loop={false} rendererSettings={lottieRendererSettings} />
      </LottieHidden>
      <LottieHidden className='desktop-plus'>
        <Lottie animationData={confetti} style={lottieStyle} loop={false} rendererSettings={lottieRendererSettings} />
      </LottieHidden>
    </LottieOverlay>
  );
}

const LottieOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 999;
  overflow: hidden;
  display: grid;
  grid-template-columns: 1fr;

  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (min-width: 1440px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

const LottieHidden = styled.div`
  display: none;
  height: 100%;
  width: 100%;

  &.tablet-plus {
    @media (min-width: 768px) {
      display: block;
    }
  }

  &.desktop-plus {
    @media (min-width: 1440px) {
      display: block;
    }
  }
`;
